<div [ngClass]="'language-selector-' + variant" class="language-selector">
  <button [matMenuTriggerFor]="languageMenu" [ngClass]="'language-button-main'" class="language-button" mat-button>
    {{ currentLanguage | uppercase }}
    <mat-icon>arrow_drop_down</mat-icon>
  </button>
  <mat-menu #languageMenu="matMenu">
    <button (click)="changeLanguage('en')" mat-menu-item>English</button>
    <button (click)="changeLanguage('de')" mat-menu-item>Deutsch</button>
    <button (click)="changeLanguage('fr')" mat-menu-item>Français</button>
    <button (click)="changeLanguage('it')" mat-menu-item>Italiano</button>
  </mat-menu>
</div>
